<template>
  <QuestionBase :question="question" :errors="[...serverErrors, ...jsErrors]" :valid="data !== null">
    <InputRadio
        v-model="data"
        :options="booleanYesNo"
        :db="db"
        :args="args"
        :skipped="skipped"
        @skipped="skipped=$event"
        @serverErrors="serverErrors=$event"
        @jsErrors="jsErrors=$event"
    />
  </QuestionBase>
</template>

<script>
import { questionLoadHelpers } from "@/components/common/questionnaires/question/helpers/questionLoadHelpers";
import { general } from "@/components/common/questionnaires/question/options/general";

import QuestionBase from "@/components/common/questionnaires/question/QuestionBase";
import InputRadio from "@/components/common/questionnaires/question/inputs/InputRadio";

export default {
  name: 'GiftsYN',
  mixins: [general, questionLoadHelpers],
  components: {
    InputRadio,
    QuestionBase
  },
  props: {
    value: {
      type: [Boolean],
      required: false
    },
    saveLocation: {
      type: String,
      default: 'amendment_data'
    }
  },
  computed: {
    data: {
      set(value) {
        this.$emit('input', value)
      },
      get () {
        return this.value
      }
    }
  },
  data () {
    return {
      question: {
        title: 'Would you like to alter, add, or remove any specific gifts of money or items in your Will?',
        subTitle: 'Specific gifts, also known as legacies, allow you to leave an exact amount of money or a particular item, like a piece of jewelry or a family heirloom, to a chosen person or charity. Over time, your financial situation might change, you might no longer own an item you previously gifted, or you may simply want to leave something special to a new person in your life. Updating your gifts ensures your current intentions are clearly and legally recorded.',
        tip: null,
      },
      db: {
        saveLocation: 'amendment_data',
        saveField: 'giftsYN',
        formPath: 'giftsYN',
        jsonSaveField: 'giftsYN',
      },
      args: {
        skippable: false,
        required: true,
      },
      serverErrors: [],
      jsErrors: [],
      skipped: false,
    }
  }
}
</script>
